import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { UserService } from 'src/app/services/shared/user.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'terra-support-pin',
  templateUrl: './support-pin.component.html',
  styleUrls: ['./support-pin.component.css']//, '../../account.component.scss']
})
export class SupportPinComponent implements OnInit {
  isLoading = false;
  isSaved = false;

  @Input()
  supportPin: string;

  constructor(
    private userService: UserService,
    private snackbarService: SnackbarService) { }

  formGroup = new UntypedFormGroup({
    supportPin: new UntypedFormControl('', [Validators.required])
  });

  ngOnInit() { }

  savePIN() {
    this.isSaved = false;

    if (this.isLoading) {
      return;
    }

    if (this.formGroup.invalid) {
      for (const i in this.formGroup.controls) {
        if (this.formGroup.controls[i]) {
          this.formGroup.controls[i].markAsTouched();
        }
      }
      return;
    }
    this.isLoading = true;

    const supprtPinValue = this.formGroup.get('supportPin').value;

    this.userService
      .saveSupportPIN(supprtPinValue)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        response => {
          this.supportPin = supprtPinValue;
          this.formGroup.reset();
          this.isSaved = true;
          this.snackbarService.showGeneralMessage('Support PIN updated');
        },
        error => { }
      );
  }
}
